<template>
  <v-app>
    <v-container v-if="isVerified" class="py-0">
      <v-row class="bg-white h-100 border pa-3 rounded">
        <v-col md="12">
          <div class="header-details">
            <table width="100%">
              <tr>
                <td>
                  <img
                    style="width: 300px; height: auto"
                    src="https://bthrust-fsm.s3.ap-southeast-1.amazonaws.com/SL012021VF/files/image/jpeg/74e7a49e-3f20-4961-a0b6-98300d1f6cd1.jpg"
                    alt="logo"
                  />
                  <div class="pt-3">
                    <div class="text-h5 fw-600">
                      #{{ costing_detail?.barcode }}
                      <v-chip
                        class="mr-2 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10 text-white"
                        :color="costing_detail?.status_relation?.color"
                        label
                      >
                        {{ costing_detail?.status_relation?.text }}
                      </v-chip>
                      <v-chip
                        v-if="costing_detail?.is_signed"
                        small
                        label
                        class="text-white"
                        color="red"
                      >
                        Signed</v-chip
                      >
                    </div>
                    <div class="text-sm grey--text text-h6 f">
                      {{ costing_detail?.job_title }}
                    </div>
                  </div>
                </td>
                <td align="right" valign="bottom">
                  <div class="">
                    <v-btn
                      outlined
                      color="red"
                      depressed
                      class="rounded bg-white mr-2"
                      @click="downloadPDFQuote"
                      ><v-icon>mdi-pdf</v-icon>Download Quote</v-btn
                    >
                    <v-btn
                      outlined
                      color="blue"
                      depressed
                      class="rounded bg-white"
                      @click="downloadPDFNew"
                      ><v-icon>mdi-pdf</v-icon>Download Costing</v-btn
                    >

                    <template v-if="costing_detail?.status == 11">
                      <v-btn
                        v-on:click="updateMoreAction('mark_as_unapproved')"
                        color="red white--text lighten-1"
                        depressed
                        class="mx-2 rounded bg-white"
                        ><v-icon>mdi-x</v-icon>Disapprove</v-btn
                      >
                      <v-btn
                        depressed
                        color="success"
                        v-on:click="updateMoreAction('mark_as_approved')"
                        class="rounded"
                        ><v-icon>mdi-right-check</v-icon>Approve</v-btn
                      >
                    </template>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </v-col>

        <v-col md="12" class="py-0 mt-2">
          <ViewLineItem is-costing />
        </v-col>
        <v-col md="6" class="py-0 mt-2">
          <v-card flat class="custom-grey-border remove-border-radius mb-4">
            <v-card-title class="headline grey lighten-4 py-1">
              <span
                class="font-weight-700 custom-headline color-custom-blue font-size-16"
                >Internal Note</span
              >
            </v-card-title>
            <v-card-text class="p-6 font-size-16">
              <v-layout class="mb-4">
                <v-flex md12 class="custom-border-right">
                  <!--  <v-card-title class="headline grey lighten-4 py-1">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >Internal Note
                        </span>
                      </v-card-title> -->
                  <read-more
                    class="mx-4 mt-1 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="
                      costing_detail?.admin_note || '<em>no Internal Note</em>'
                    "
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="6" class="py-0 mt-2">
          <v-card flat class="custom-grey-border remove-border-radius mb-4">
            <v-card-title class="headline grey lighten-4 py-1">
              <span
                class="font-weight-700 custom-headline color-custom-blue font-size-16"
                >Costing Attachments</span
              >
            </v-card-title>
            <v-card-text class="p-6 font-size-16">
              <template v-if="costing_detail.attachment_relation?.length">
                <v-col
                  v-for="(row, index) in costing_detail?.attachment_relation"
                  :key="index"
                  class="border-bottom d-flex"
                  :class="{
                    'custom-border-top': index == 0,
                    'orange_lighten-5': index % 2 == 0,
                  }"
                >
                  <div class="px-4" style="width: 60px">
                    <template v-if="row.extension && isImage(row.extension)">
                      <ImageTemplate
                        :src="row.file.url"
                        style="max-width: 50px; width: 50px"
                      ></ImageTemplate>
                    </template>
                    <template v-else>
                      <inline-svg
                        style="max-width: 50px; width: 50px"
                        :src="$assetURL(`media/mime/${row.extension}.svg`)"
                      />
                    </template>
                  </div>

                  <div
                    :style="get_col_style(extensive)"
                    class="px-4 text-truncate"
                  >
                    <b
                      class="blue--text text--darken-4 cursor-pointer"
                      v-on:click="doAction(row, 'download')"
                      >{{ row.name }}</b
                    >
                    <b v-if="row.type_in_module" class="ml-3 red--text"
                      >({{ row.type_in_module }} -
                      {{ row.module_type_parent }} )</b
                    >
                    <div>
                      <b>Size:</b
                      >{{ Number(Number(row.size) / 1024).toFixed(2) }}KB
                    </div>
                    <div
                      v-if="
                        row.type == 20 ||
                        row.type == 5020 ||
                        row.type == 5019 ||
                        row.type == 5017
                      "
                    >
                      <v-chip
                        :color="getTypeColor(row.type)"
                        outlined
                        text-color=""
                        label
                        small
                      >
                        {{ getTypeName(row.type) }}</v-chip
                      >
                    </div>
                  </div>
                  <div
                    style="width: 30%"
                    class="px-4 d-flex flex-wrap"
                    v-if="extensive"
                  >
                    <div class="mr-10">
                      <div>
                        <b class="d-inline-block" style="min-width: 64px"
                          >Start </b
                        >:&nbsp;&nbsp;
                        <span v-if="row?.start_date">
                          {{ formatDate(row.start_date) }}
                        </span>
                        <em class="text-muted" v-else> no start </em>
                      </div>
                      <div>
                        <b class="d-inline-block" style="min-width: 64px"
                          >End </b
                        >:&nbsp;&nbsp;
                        <span v-if="row?.end_date">
                          {{ formatDate(row.end_date) }}
                        </span>
                        <em class="text-muted" v-else> no end </em>
                      </div>
                      <div>
                        <b class="d-inline-block" style="min-width: 64px"
                          >Reminder </b
                        >:&nbsp;&nbsp;
                        <span v-if="row?.reminder_date">
                          {{ formatDate(row.reminder_date) }}
                        </span>
                        <em class="text-muted" v-else> no reminder </em>
                      </div>
                    </div>
                  </div>
                  <div style="width: 20%" class="px-4" v-if="extensive">
                    <template v-if="row.tags && row.tags?.length > 0">
                      <v-chip
                        small
                        v-for="(tagRow, index) in row.tags"
                        :key="index"
                        class="mr-2 mb-1"
                        text-color="white"
                        :color="tagRow?.color"
                        >{{ tagRow.tag }}</v-chip
                      >
                    </template>
                    <em v-else class="text-muted"> no tags</em>
                  </div>
                  <div style="width: 15%" class="px-4 d-flex flex-wrap">
                    <div class="mr-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-if="row.added_at"
                            class="mx-2 my-1 custom-grey-border"
                            color="blue-grey darken-1"
                            text-color="white"
                            v-bind="attrs"
                            v-on="on"
                            style="height: 25px !important"
                          >
                            <v-avatar left>
                              <v-icon>mdi-clock-outline</v-icon>
                            </v-avatar>
                            <p class="m-0 custom-nowrap-ellipsis">
                              {{ formatDate(row.added_at) }}
                            </p>
                          </v-chip>
                        </template>
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ formatDate(row.added_at) }}
                          {{ formatDateStartedNew(row.added_at) }}
                        </p>
                      </v-tooltip>
                    </div>
                  </div>
                  <div style="width: 10%" class="px-4 d-flex">
                    <v-spacer></v-spacer>
                    <v-btn
                      v-on:click="doAction(row, 'download')"
                      small
                      icon
                      depressed
                      color="blue darken-4"
                      class="mx-1"
                    >
                      <v-icon medium>mdi-download</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </template>
              <template v-else>
                <v-col class="text-center border-top">
                  <p class="m-0 py-3 row-not-found text-center">
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                      width="30"
                    />
                    Uhh... There are no file at the moment.
                  </p>
                </v-col>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Dialog :common-dialog="dialog">
      <template v-slot:title> Verification </template>
      <template v-slot:body>
        <v-form
          ref="verificationForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="verifyCustomer"
        >
          <v-row>
            <v-col md="12">
              <v-text-field
                v-model.trim="verificationCode"
                dense
                filled
                label="Security Code"
                solo
                flat
                :disabled="formLoading || pageLoading"
                :loading="formLoading"
                color="cyan"
                :rules="[
                  validateRules.required(verificationCode, 'Security Code'),
                  validateRules.minLength(verificationCode, 'Security Code', 4),
                  validateRules.maxLength(
                    verificationCode,
                    'Security Code',
                    10
                  ),
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="!formValid || formLoading || pageLoading"
          :loading="formLoading"
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          v-on:click="verifyCustomer"
        >
          Submit
        </v-btn>
      </template>
    </Dialog>
    <Dialog :common-dialog="confirm_dialog" :dialog-width="dialogWidth">
      <template v-slot:title> Confirmation </template>
      <template v-slot:body>
        <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
          <v-container class="px-10" fluid>
            <p
              class="font-weight-600 font-size-19"
              v-if="confirm_type != 'mark_as_send'"
            >
              Are you sure you want to
              <span class="font-weight-700">{{ get_confirm_title() }}</span
              >?
            </p>
            <p v-else class="font-weight-600 font-size-19">
              Are you sure you have
              <span class="font-weight-700"
                >send out the costing..... already to customer</span
              >?
            </p>
            <v-layout
              class="my-4"
              v-if="
                confirm_type == 'mark_as_approved' ||
                confirm_type == 'mark_as_unapproved'
              "
            >
              <v-flex>
                <label class="font-weight-500 font-size-16 required"
                  >Remark</label
                >
                <TextAreaField
                  :rules="[validateRules.required(actionData.remark, 'Remark')]"
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  v-model="actionData.remark"
                  placeholder="Remark"
                  solo
                  flat
                  row-height="25"
                  counter="200"
                />
              </v-flex>
            </v-layout>
            <v-layout
              class="mt-4"
              v-if="
                confirm_type == 'mark_as_approved' ||
                confirm_type == 'mark_as_unapproved'
              "
            >
              <v-flex md12>
                <label class="font-weight-500 font-size-16">Attachment</label>

                <file-upload v-model="actionData.attachments" :maxLimit="5">
                </file-upload>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="confirm_loading"
          v-on:click="confirm_dialog = false"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          No! Close
        </v-btn>
        <v-btn
          v-on:click="confirm_submit()"
          :disabled="!formValid || confirm_loading || !actionData.remark"
          :loading="confirm_loading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
        >
          Yes! Continue
        </v-btn>
      </template>
    </Dialog>
    <template v-if="validationErrorBag.length">
      <v-snackbar
        :timeout="5000"
        :value="true"
        top
        color="error"
        right
        v-for="(error, index) in validationErrorBag"
        :key="index"
      >
        {{ error }}
      </v-snackbar>
    </template>
    <template v-if="validationSuccess">
      <v-snackbar
        :timeout="5000"
        :value="true"
        top
        color="#0abb87"
        right
        style="font-weight: 600 !important; font-size: 12px !important"
      >
        {{ validationSuccess }}
      </v-snackbar>
    </template>
  </v-app>
</template>
<style type="text/css" scoped>
.quotation {
  font-weight: 600;
  text-decoration: underline;
}
.customer-font-bold {
  font-weight: 600;
}
.w-100px {
  width: 100px;
  display: inline-block;
}
.fw-700 {
  font-weight: 700;
}
.mr-5 {
  margin-right: 20px;
}
.fw-600 {
  font-weight: 600;
}
.customer-border-top {
  border-top: solid 2px #000;
}
.customer-border-bottom {
  border-bottom: solid 2px #000;
}
.customer-border-right {
  border-right: solid 2px #000;
}
.customer-border-left {
  border-left: solid 2px #000;
}
.line-items td {
  padding: 4px;
}
table > tbody > tr.signature-pad > td {
  width: 50% !important;
}
.quotation-approved {
  text-align: center;
  padding: 40px 0;
  background: #ebf0f5;
}

.quotation-approved h1 {
  color: #88b04b;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 10px;
}
.quotation-approved.quotation-rejected h1 {
  color: #f34747;
}
.quotation-approved p {
  color: #404f5e;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  margin: 0;
}
.quotation-approved i {
  color: #9abc66;
  font-size: 100px;
  line-height: 200px;
  margin-left: -15px;
}
.quotation-approved.quotation-rejected i {
  color: #f34747;
  font-size: 100px;
  line-height: 200px;
  margin-left: -15px;
}
.quotation-approved .card {
  background: white;
  padding: 60px;
  border-radius: 4px;
  box-shadow: 0 2px 3px #c8d0d8;
  display: inline-block;
  margin: 0 auto;
}
</style>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import {
  VERIFY_QUOTATION_CUSTOMER,
  QUERY,
  PATCH,
  /*   POST, */
} from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin.js";
import ObjectPath from "object-path";
import JwtService from "@/core/services/jwt.service";
import {
  SET_VIEW_CALCULATION,
  SET_VIEW_LINE_ITEM,
} from "@/core/services/store/line.item.v2.module";
import moment from "moment-timezone";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import ViewLineItem from "@/view/components/ViewLineItem.vue";
import FileUpload from "@/view/components/app-component/FileInput";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { toSafeInteger } from "lodash";
import ImageTemplate from "@/view/pages/Image";

export default {
  name: "quotation-approve",
  mixins: [ValidationMixin, CommonMixin],
  data: () => {
    return {
      extensive: false,
      ticketTab: "summary",
      costingLineItems: [],
      quotation_line_items: [],
      dialog: true,
      formValid: true,
      valid_till: moment().format("YYYY-MM-DD"),
      download_date: moment().format("YYYY-MM-DD"),
      currentDate: moment().format("DD-MM-YYYY"),
      formLoading: false,
      isVerified: false,
      isSubmitted: false,
      isRejected: false,
      pageLoading: false,
      action_dialog: false,
      accepted_dialog: false,
      action_type: null,
      tokenNotFound: false,
      verificationCode: null,
      attachments: [],
      securityToken: null,
      today_date: null,
      customer: {},
      billing: {},
      billing_person: {},
      approver: {},
      prepared: {},
      sale_by: {},
      selected_products: [],
      selected_equipments: [],
      customer_signature: null,
      validationErrorBag: new Array(),
      validationSuccess: null,
      costing_detail: new Object({
        id: null,
        barcode: null,
        customer: {
          display_name: null,
          company_name: null,
        },
        billing: {
          unit_no: null,
          street_1: null,
          street_2: null,
          zip_code: null,
          country: {
            name: null,
          },
          property_address: null,
        },
        job_title: null,
        sales: null,
        attention: null,
        client_remark: null,
        term_conditions: null,
        additional_remarks: null,
        total: null,
        sub_total: null,
        discount_value: null,
        date: null,
        date_formatted: null,
        property_person: {
          primary_phone: null,
          primary_email: null,
          full_name: null,
        },
        line_items: [
          {
            id: null,
            description: null,
            quantity: null,
            product: {
              name: null,
              unit: {
                id: null,
                text: null,
              },
            },
            sub_total: null,
            discount: null,
          },
        ],
      }),
      company_detail: new Object(),
      actionDetail: {
        first_name: null,
        last_name: null,
        email: null,
        remark: null,
        attachments: [],
        signature: null,
      },
      header_footer: new Object(),
      sales_signature: new Object(),
      comments: null,
      notesLoading: false,
      msgList: [],
      confirm_type: null,
      statusLoading: false,
      confirm_loading: false,
      confirm_dialog: false,

      actionData: {
        remark: null,
        attachments: [],
        status: null,
        approver: null,
      },
    };
  },
  components: {
    Dialog,
    TextAreaField,
    ViewLineItem,
    "file-upload": FileUpload,
    ImageTemplate,
  },
  methods: {
    isImage(ext) {
      if (find(this.extensionArray, (row) => row == ext.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    getTypeName(type) {
      if (type == 2 || type == 20) {
        return "Internal";
      } else if (type == 5018) {
        return "Rejected";
      } else if (type == 5017) {
        return "Accepted";
      } else if (type == 5019) {
        return "Approved";
      }
    },
    getTypeColor(type) {
      if (type == 20 || type == 2) {
        return "blue-grey darken-1";
      } else if (type == 5018) {
        return "red darken-1";
      } else if (type == 5017) {
        return "green darken-1";
      } else if (type == 5007 || type == 5019) {
        return "green darken-1";
      }
    },
    formatDateStartedNew(param) {
      return moment(param).format("hh:mm A");
    },
    doAction(row, param) {
      switch (param) {
        case "download":
          window.open(row.file.url, "_blank");
          break;
      }
    },
    get_col_style(param) {
      let width = 65;
      if (param) {
        width = 30;
      }
      return { width: `${width}%` };
    },
    confirm_submit() {
      const _this = this;
      const validateStatus = _this.$refs.statusForm.validate();
      const formErrors = _this.validateForm(_this.$refs.statusForm);
      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }
      if (!validateStatus) {
        return false;
      }
      _this.confirm_loading = true;
      switch (this.confirm_type) {
        case "mark_as_approved":
          this.updateStatus("mark_as_approved");
          break;
        case "mark_as_unapproved":
          this.updateStatus("mark_as_unapproved");
          break;
      }
    },
    updateStatus(status) {
      if (this.statusLoading) {
        return false;
      }
      /*   this.actionData.attachments = this.attachments; */
      this.actionData.status = status;
      this.actionData.approver = toSafeInteger(this.approver?.id);
      this.statusLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "costing/" + this.costing_detail?.id + "/status",
          data: this.actionData,
        })
        .then((response) => {
          if (response && response.message) {
            this.validationSuccess = response.message;
          }

          this.verifyCustomer();
          this.confirm_loading = false;
          this.confirm_dialog = false;
          this.confirm_type = null;
        })
        .catch((error) => {
          if (error && error.data && error.data.message) {
            this.validationErrorBag = error.data.message.split("<br>");
          } else {
            this.validationErrorBag.push(error.data.message);
          }
          this.logError(error);
        })
        .finally(() => {
          this.statusLoading = false;
          this.confirm_loading = false;
        });
    },
    get_confirm_title() {
      if (this.confirm_type == "mark_as_closed") {
        return "mark as lost";
      } else if (this.confirm_type == "mark_as_cancelled") {
        return "mark as cancelled";
      } else if (this.confirm_type == "mark_as_pending") {
        return "mark as pending";
      } else if (this.confirm_type == "mark_as_rejected") {
        return "mark as rejected";
      } else if (this.confirm_type == "mark_as_accepted") {
        return "mark as accepted";
      } else if (this.confirm_type == "mark_as_approved") {
        return "mark as approved";
      } else if (this.confirm_type == "mark_as_send") {
        return "Send Quotation";
      } else if (this.confirm_type == "submited_for_Approver") {
        return "Submit For Approval";
      } else if (this.confirm_type == "mark_as_unapproved") {
        return "mark as disapproved";
      }
    },
    updateMoreAction(type) {
      switch (type) {
        case "mark_as_approved":
          this.$refs?.statusForm?.validate();
          this.actionData.remark = null;
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_approved";
          break;
        case "mark_as_unapproved":
          this.$refs?.statusForm?.validate();
          this.actionData.remark = null;
          this.confirm_dialog = true;
          this.confirm_type = "mark_as_unapproved";
          break;
      }
    },
    downloadPDFQuote() {
      const token = JwtService.getToken();
      const url = `${this.$apiURL}quotation/${this.costing_detail?.quotation_relation?.id}/pdf/download/HYC_Pn_Inst?token=${token}&date=${this.download_date}&valid_till=${this.valid_till}`;
      window.open(url, "_blank");
    },
    downloadPDFNew() {
      const { id } = this.costing_detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}costing-v1/${id}/pdf?&token=${token}&action=download`;
      // console.log(url);
      window.open(url, "_blank");
    },

    verifyCustomer() {
      const _this = this;

      if (!_this.$refs.verificationForm.validate()) {
        return false;
      }

      _this.formLoading = true;
      _this.isVerified = false;

      _this.validationErrorBag = new Array();

      _this.$store
        .dispatch(VERIFY_QUOTATION_CUSTOMER, {
          url: "costing/verify",
          data: { code: _this.verificationCode },
          token: _this.securityToken,
        })
        .then(({ data }) => {
          const status = ObjectPath.get(data, "costing_detail.status", 0);

          if (status == 10) {
            _this.isRejected = true;
          } else if (status == 8) {
            _this.isSubmitted = true;
          }

          _this.costing_detail = data.costing_detail;
          _this.getLineItems({ costing: _this.costing_detail.id });
          _this.company_detail = data.company_detail;

          _this.customer = ObjectPath.get(data, "costing_detail.customer", {});
          _this.billing = ObjectPath.get(data, "costing_detail.billing", {});
          _this.billing_person = ObjectPath.get(
            data,
            "costing_detail.billing_person",
            {}
          );
          _this.approver = ObjectPath.get(data, "approver", {});
          _this.prepared = ObjectPath.get(data, "prepared", {});
          _this.sale_by = ObjectPath.get(data, "sale_by", {});

          _this.header_footer = data.header_footer;
          _this.sales_signature = data.sales_signature;
          _this.today_date = data.today_date;
          _this.dialog = false;
          _this.isVerified = true;
        })
        .catch(({ response }) => {
          if (response && response.data && response.data.message) {
            _this.validationErrorBag = response.data.message.split("<br>");
          } else {
            _this.validationErrorBag.push(
              "Something went wrong, Please try again later."
            );
          }
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
    getLineItems(data) {
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "line-item/costing",
          data,
        })
        .then(({ data }) => {
          this.costingLineItems = data;
          this.$store.dispatch(SET_VIEW_LINE_ITEM, this.costingLineItems);
          this.$store.dispatch(SET_VIEW_CALCULATION, {
            total_selling: this.costing_detail?.total_selling,
            total_cost_value: this.costing_detail?.total_cost_value,
            total_margin: this.costing_detail?.total_margin,
            discount_value: this.costing_detail?.discount_value,
            discount_type: this.lodash.toSafeInteger(
              this.costing_detail?.discount_type
            ),
            main_discount: this.costing_detail?.main_discount,
            lump_discount_value: this.costing_detail?.lump_discount_value,
            lump_discount_type: this.lodash.toSafeInteger(
              this.costing_detail?.lump_discount_type
            ),
            lump_sum_discount: this.costing_detail?.lump_sum_discount,
            discounted_total_selling:
              this.costing_detail?.discounted_total_selling,
            grand_total: this.costing_detail?.grand_total,
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
  },
  mounted() {
    const _this = this;

    if (_this.verificationCode) {
      _this.verifyCustomer();
    }
    _this.$refs?.statusForm?.validate();
  },
  created() {
    const _this = this;

    if (_this.$route.query && _this.$route.query.token) {
      _this.securityToken = _this.$route.query.token;
      _this.verificationCode = _this.$route.query["security-code"];
    } else {
      _this.dialog = false;
      _this.tokenNotFound = true;
    }
  },
  computed: {
    /* valid_signature() {
      return this.customer_signature
        ? this.customer_signature.isEmpty()
        : false;
    }, */
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
  },
};
</script>
<style scoped>
.wrapper {
  margin: 0 auto;
  padding: 0px 14px;
}

.wrapper table td {
  font-size: 12px;
}
.v-application td {
  padding: 4px 8px;
}

.tabs-summary .theme--light.v-tabs-items {
  background-color: transparent !important;
}
.signature-pad-wrap {
  height: 128px !important;
  margin-top: 4px;
}
</style>
